import React from 'react';
import Modal from 'components/UI/DialogModal';
import { CircularProgress, Grid, Stack, Typography } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { getPlans } from 'framework/plans';
import useFetchSection from 'hooks/useFetchSection';
import { ISubscription } from 'models/subscription';
import { IFormField } from 'models/app';
import { InputTypes } from 'constants/enums';
import Form from 'components/UI/Form';



interface Props {
  open: boolean;
  loading: boolean;
  title:string;
  subscription:ISubscription;
  description:string;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const PayInAdvanceModal: React.FC<Props> = ({ open,subscription, loading, title, description, onClose,onChanges, onSubmit }) => {


  const {
    loading:loadingPlans,
    data: Plans,
    error,
    revalidate,
  } = useFetchSection({
    fetchData: () => getPlans(`?ServiceId=${subscription.serviceId}`),
    fetchPermission: async () => null,
    section: "Plans of service",
  
  });

  if(loadingPlans) return null



  let options = Plans!.map((plan) => {return { value: plan.planId.toString(), label: plan.planName }});

  let basicFields: IFormField[] = [
 
    {
      name: 'advancePaymentId',
      label: 'Plans',
      placeholder: 'Select plan',
      type: InputTypes.SELECT,
      options:options,
      internalLabel: true,
      required: true
    },
    
  ];

  return (<>
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="lg"
      children={<Stack direction={'column'} p={2} gap={2}>
        <Typography variant="h6">{description}</Typography>
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="outlined"
            sx={{ color: 'warning.main', borderColor: 'warning.main' }}
            size='large' onClick={onClose}>
            {'Cancel'}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {'Confirm'}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default PayInAdvanceModal;
